import React, { useState } from "react";
import { useUserInfoContext } from "../../../global/hooks/useUserInfoContext";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { Card, CardContent, Box, Typography, TextField, Button } from "@mui/material";
import { useAssignStaff } from "../../services/ApiHandlerService";

const StaffEditCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();
    const { userInfo } = useUserInfoContext();
    const [staffAapId, setStaffAapId] = useState("");
    const { assignStaff } = useAssignStaff();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    const handleStaffChange = async () => {
        if (staffAapId.trim()) {
            await assignStaff(staffAapId, selectedIssue.issueKey!);
            setStaffAapId("");
        }
    };
    const handleSelfAssign = async () => {
        if (userInfo?.AapId) {
            await assignStaff(userInfo.AapId, selectedIssue.issueKey!);
            setStaffAapId("");
        }
    };
    const handleCancel = () => {
        setStaffAapId("");
    };

    return (
        <Card sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0 }}>
            <CardContent>
                <Typography variant="body2" gutterBottom>
                    <strong>Add/Remove Staff:</strong>
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Typography variant="body2" sx={{ mr: 1, minWidth: 60 }}>
                        <strong>AAP ID:</strong>
                    </Typography>
                    <TextField
                        id="staff_textbox"
                        variant="outlined"
                        name="staffAapId"
                        size="small"
                        value={staffAapId}
                        onChange={e => setStaffAapId(e.target.value)}
                        sx={{ width: '100px', '& .MuiInputBase-input': { padding: '6px 8px' } }}
                        InputLabelProps={{ sx: { fontSize: 12 } }}
                        inputProps={{ style: { height: '1.2em', padding: '6px 8px' } }}
                    />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 3, my: 2 }}>
                    <Button variant="contained" size="small" onClick={handleStaffChange}>
                        Add
                    </Button>
                    <Button variant="contained" size="small" onClick={handleStaffChange}>
                        Remove
                    </Button>
                    <Button variant="contained" size="small" onClick={handleSelfAssign}>
                        {selectedIssue.assignedTo?.some(
                            (staff: any) =>
                                String(staff.customerKey || "").toLowerCase() === String(userInfo?.CustomerKey || "").toLowerCase()
                        ) ? "Remove Me" : "Assign To Me"}
                    </Button>
                    <Button variant="outlined" color="secondary" size="small" onClick={handleCancel}>
                        Cancel
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StaffEditCard;
